import React, { useState } from 'react';
import { CentsPalette } from '../../../../../utils/colors';
import PicklistButton from '../../../container/buttons/PicklistButton';
import useFilters from '../../../../../hooks/useFilters';
import { PicklistItem } from '../../../../../types/filters';
import { translations } from '../../../../../utils/translations/translations-manager';

interface Props {
  picks: PicklistItem[]
  filterKey: string
}

const PicklistFilter: React.FC<Props> = ({ picks, filterKey }) => {
  const [isPicklistVisible, setIsPicklistVisible] = useState(false)
  const { addFilter, getActiveFilters } = useFilters()
  const emptyPick: PicklistItem = {
    id: '',
    label: () => translations.texts.select_an_option.toString()
  }
  const [selectedPick, setSelectedPick] = useState(emptyPick)

  const togglePicklist = () => {
    setIsPicklistVisible(!isPicklistVisible)
  }

  const handleSelect = (id: string) => {
    addFilter(filterKey, id)
    setSelectedPick(picks.find(pick => id === pick.id) ?? emptyPick)
    setIsPicklistVisible(false)
  }

  return (
    <div className="picklist relative h-10 w-[302px] rounded-2xl">
      <PicklistButton label={selectedPick.label()} isSelected={true} onClickFunction={togglePicklist} />

      <button onClick={togglePicklist}>
        <svg id="picklist-arrow" className={`z-30 absolute right-4 top-2 transition-transform duration-300 ${isPicklistVisible ? "rotate-180" : "rotate-0"}`} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 8.01777L11.6161 14.6339C12.1043 15.122 12.8957 15.122 13.3839 14.6339L20 8.01777" stroke={CentsPalette.cents_black} strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </button>

      <li className={`${isPicklistVisible ? "max-h-[88vh]" : "max-h-0"} z-40 absolute top-12 w-[300px] bg-cents-white rounded-2xl list-none overflow-hidden shadow-md transition-[max-height] duration-700`}>
        {picks
          .filter(pick => pick.id !== selectedPick.id)
          .map(pick => (
            <ul key={pick.id}>
              <PicklistButton label={pick.label()} isSelected={false} onClickFunction={() => handleSelect(pick.id)} />
            </ul>
          ))
        }
      </li>
    </div>
  );
};

export default PicklistFilter;